//#region src/adapters/prismic/types/link.ts
let PrismicLinkTypeEnum = /* @__PURE__ */ function(PrismicLinkTypeEnum) {
	PrismicLinkTypeEnum["Any"] = "Any";
	PrismicLinkTypeEnum["Document"] = "Document";
	PrismicLinkTypeEnum["Media"] = "Media";
	PrismicLinkTypeEnum["Web"] = "Web";
	PrismicLinkTypeEnum["File"] = "File";
	return PrismicLinkTypeEnum;
}({});
//#endregion
//#region src/adapters/static/lookup-static.ts
const lookupStatic = (record, locale, kind) => {
	const content = record[locale];
	if (!content) throw new Error(`No static ${kind} content for locale "${locale}"`);
	return content;
};
//#endregion
//#region src/adapters/static/social-links.ts
const socialLinks = [
	{
		platform: "linkedin",
		name: "LinkedIn",
		url: "https://www.linkedin.com/company/pleo-company"
	},
	{
		platform: "twitter",
		name: "Twitter",
		url: "https://www.twitter.com/pleo"
	},
	{
		platform: "facebook",
		name: "Facebook",
		url: "https://www.facebook.com/pleo.io"
	},
	{
		platform: "instagram",
		name: "Instagram",
		url: "https://www.instagram.com/pleo.io"
	},
	{
		platform: "youtube",
		name: "YouTube",
		url: "https://www.youtube.com/channel/UCQQitvQIlEgIxNyLlOgilXQ"
	}
];
//#endregion
//#region src/adapters/static/footer/index.ts
const staticFooters = {
	"en-us": {
		entity: "Pleo North America, Inc.",
		address: [{
			type: "paragraph",
			text: "18th Ave S & Chet Atkins Pl",
			spans: []
		}, {
			type: "paragraph",
			text: "Nashville, TN 37212",
			spans: []
		}],
		terms_body: "Pleo Mastercard® Prepaid Card is issued by Pathward® N.A., Member FDIC, pursuant to a license from Mastercard International Incorporated. Accepted for use anywhere Debit Mastercard is accepted. No cash access. Mastercard and the circles design are registered trademarks of Mastercard International Incorporated.",
		copyright_text: "All rights reserved.",
		financial_partner_terms_text: "",
		financial_partner_copyright_text: "",
		contact_us: "Chat with us",
		sales_email: null,
		info_email: null,
		support_email: null,
		product_heading: "Product",
		resources_heading: "Resources",
		company_heading: "Company",
		legal_heading: "Legal",
		solutions_heading: "Solutions",
		partnerships_heading: "",
		product_links: [{
			text: "Status",
			link: {
				link_type: "Web",
				uid: null,
				type: null,
				lang: null,
				target: null,
				url: "https://status.pleo.io/"
			}
		}],
		resources_links: [{
			text: "Help Centre",
			link: {
				link_type: "Web",
				uid: null,
				type: null,
				lang: null,
				target: null,
				url: "https://help.pleo.io/en/"
			}
		}, {
			text: "Developers",
			link: {
				link_type: "Web",
				uid: null,
				type: null,
				lang: null,
				target: null,
				url: "https://developers.pleo.io/reference/introduction"
			}
		}],
		company_links: [{
			text: "Careers",
			link: {
				link_type: "Web",
				uid: null,
				type: null,
				lang: null,
				target: null,
				url: "https://www.pleo.io/en/careers"
			}
		}, {
			text: "Legal",
			link: {
				link_type: "Document",
				uid: null,
				type: "legal_page",
				lang: "en-us",
				target: null,
				url: "/us/legal"
			}
		}],
		legal_links: [
			{
				text: "Cardholder Agreement",
				link: {
					link_type: "Web",
					uid: null,
					type: null,
					lang: null,
					target: null,
					url: "/us/legal"
				}
			},
			{
				text: "Master Service Agreement",
				link: {
					link_type: "Web",
					uid: null,
					type: null,
					lang: null,
					target: null,
					url: "/us/legal"
				}
			},
			{
				text: "Privacy Policy",
				link: {
					link_type: "Web",
					uid: null,
					type: null,
					lang: null,
					target: null,
					url: "/us/legal"
				}
			},
			{
				text: "Fraud awareness",
				link: {
					link_type: "Web",
					uid: null,
					type: null,
					lang: null,
					target: null,
					url: "https://www.pleo.io/legal-documents/pleo-fraud-awareness-us.pdf"
				}
			},
			{
				text: "Complaints process",
				link: {
					link_type: "Web",
					uid: null,
					type: null,
					lang: null,
					target: null,
					url: "https://www.pleo.io/legal-documents/pleo-complaint-process-na.pdf"
				}
			},
			{
				text: "Code of Conduct",
				link: {
					link_type: "Web",
					uid: null,
					type: null,
					lang: null,
					target: null,
					url: "https://www.pleo.io/en/code-of-conduct"
				}
			}
		],
		solutions_links: [],
		partnerships_links: []
	},
	"pt-pt": {
		entity: "Pleo Technologies A/S (36538686) and Pleo Financial Services A/S (39155435)",
		address: [{
			type: "paragraph",
			text: "Ravnsborg Tværgade 5C 2200 Copenhagen N Denmark",
			spans: []
		}],
		terms_body: "The Pleo Card is issued by Pleo Financial Services A/S pursuant to a license from Mastercard International Incorporated. Mastercard and the Mastercard Brand Mark are registered trademarks of Mastercard International Incorporated. Pleo Financial Services A/S is a regulated Electronic Money Institution, authorised by the Financial Supervisory Authority, Denmark. Registered Office of Pleo Financial Services A/S: Ravnsborg Tværgade 5 C, 4. Copenhagen N, 2200, Denmark. CVR Number: 39155435. All communications should be sent to Pleo Technologies A/S, Ravnsborg Tværgade 5C, 2200 Copenhagen N, Denmark",
		copyright_text: "All rights reserved",
		financial_partner_terms_text: "",
		financial_partner_copyright_text: "",
		contact_us: "Chat with us",
		sales_email: null,
		info_email: null,
		support_email: null,
		product_heading: "Product",
		resources_heading: "Resources",
		company_heading: "Company",
		legal_heading: "Legal",
		solutions_heading: "Solutions",
		partnerships_heading: "",
		product_links: [{
			text: "Status",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://status.pleo.io/"
			}
		}],
		resources_links: [{
			text: "Help Centre",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://help.pleo.io/en/"
			}
		}, {
			text: "Developers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://developers.pleo.io/reference/introduction"
			}
		}],
		company_links: [{
			text: "Careers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://www.pleo.io/en/careers"
			}
		}, {
			text: "Legal",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "/pt/legal"
			}
		}],
		legal_links: [
			{
				text: "Master Service Agreement",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-master-service-agreement-eea-eu.pdf"
				}
			},
			{
				text: "Privacy Policy",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-privacy-policy-en.pdf"
				}
			},
			{
				text: "Fraud awareness",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-fraud-awereness-en.pdf"
				}
			},
			{
				text: "Complaints process",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-complaint-process-en.pdf"
				}
			},
			{
				text: "Code of Conduct",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/en/code-of-conduct"
				}
			}
		],
		solutions_links: [],
		partnerships_links: []
	},
	"de-at": {
		entity: "Pleo Technologies A/S (36538686) and Pleo Financial Services A/S (39155435)",
		address: [{
			type: "paragraph",
			text: "Ravnsborg Tværgade 5C 2200 Copenhagen N Denmark",
			spans: []
		}],
		terms_body: "The Pleo Card is issued by Pleo Financial Services A/S pursuant to a license from Mastercard International Incorporated. Mastercard and the Mastercard Brand Mark are registered trademarks of Mastercard International Incorporated. Pleo Financial Services A/S is a regulated Electronic Money Institution, authorised by the Financial Supervisory Authority, Denmark. Registered Office of Pleo Financial Services A/S: Ravnsborg Tværgade 5 C, 4. Copenhagen N, 2200, Denmark. CVR Number: 39155435. All communications should be sent to Pleo Technologies A/S, Ravnsborg Tværgade 5C, 2200 Copenhagen N, Denmark",
		copyright_text: "All rights reserved",
		financial_partner_terms_text: "",
		financial_partner_copyright_text: "",
		contact_us: "Chat with us",
		sales_email: null,
		info_email: null,
		support_email: null,
		product_heading: "Product",
		resources_heading: "Resources",
		company_heading: "Company",
		legal_heading: "Legal",
		solutions_heading: "Solutions",
		partnerships_heading: "",
		product_links: [{
			text: "Status",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://status.pleo.io/"
			}
		}],
		resources_links: [{
			text: "Help Centre",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://help.pleo.io/en/"
			}
		}, {
			text: "Developers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://developers.pleo.io/reference/introduction"
			}
		}],
		company_links: [{
			text: "Careers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://www.pleo.io/en/careers"
			}
		}, {
			text: "Legal",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "/at/legal"
			}
		}],
		legal_links: [
			{
				text: "Master Service Agreement",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-master-service-agreement-en-de.pdf"
				}
			},
			{
				text: "Privacy Policy",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-privacy-policy-de.pdf"
				}
			},
			{
				text: "Fraud awareness",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-fraud-awereness-en.pdf"
				}
			},
			{
				text: "Complaints process",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-complaint-process-en.pdf"
				}
			},
			{
				text: "Code of Conduct",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/en/code-of-conduct"
				}
			},
			{
				text: "Impressum",
				link: {
					link_type: "Web",
					uid: null,
					type: null,
					lang: null,
					target: null,
					url: "https://www.pleo.io/de/impressum-page"
				}
			}
		],
		solutions_links: [],
		partnerships_links: []
	},
	"nl-be": {
		entity: "Pleo Technologies A/S (36538686) and Pleo Financial Services A/S (39155435)",
		address: [{
			type: "paragraph",
			text: "Ravnsborg Tværgade 5C 2200 Copenhagen N Denmark",
			spans: []
		}],
		terms_body: "The Pleo Card is issued by Pleo Financial Services A/S pursuant to a license from Mastercard International Incorporated. Mastercard and the Mastercard Brand Mark are registered trademarks of Mastercard International Incorporated. Pleo Financial Services A/S is a regulated Electronic Money Institution, authorised by the Financial Supervisory Authority, Denmark. Registered Office of Pleo Financial Services A/S: Ravnsborg Tværgade 5 C, 4. Copenhagen N, 2200, Denmark. CVR Number: 39155435. All communications should be sent to Pleo Technologies A/S, Ravnsborg Tværgade 5C, 2200 Copenhagen N, Denmark",
		copyright_text: "All rights reserved",
		financial_partner_terms_text: "",
		financial_partner_copyright_text: "",
		contact_us: "Chat with us",
		sales_email: null,
		info_email: null,
		support_email: null,
		product_heading: "Product",
		resources_heading: "Resources",
		company_heading: "Company",
		legal_heading: "Legal",
		solutions_heading: "Solutions",
		partnerships_heading: "",
		product_links: [{
			text: "Status",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://status.pleo.io/"
			}
		}],
		resources_links: [{
			text: "Help Centre",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://help.pleo.io/en/"
			}
		}, {
			text: "Developers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://developers.pleo.io/reference/introduction"
			}
		}],
		company_links: [{
			text: "Careers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://www.pleo.io/en/careers"
			}
		}, {
			text: "Legal",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "/nl-be/legal"
			}
		}],
		legal_links: [
			{
				text: "Master Service Agreement",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-master-service-agreement-eea-eu.pdf"
				}
			},
			{
				text: "Privacy Policy",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-privacy-policy-en.pdf"
				}
			},
			{
				text: "Fraud awareness",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-fraud-awereness-en.pdf"
				}
			},
			{
				text: "Complaints process",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-complaint-process-en.pdf"
				}
			},
			{
				text: "Code of Conduct",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/en/code-of-conduct"
				}
			}
		],
		solutions_links: [],
		partnerships_links: []
	},
	"fr-be": {
		entity: "Pleo Technologies A/S (36538686) and Pleo Financial Services A/S (39155435)",
		address: [{
			type: "paragraph",
			text: "Ravnsborg Tværgade 5C 2200 Copenhagen N Denmark",
			spans: []
		}],
		terms_body: "The Pleo Card is issued by Pleo Financial Services A/S pursuant to a license from Mastercard International Incorporated. Mastercard and the Mastercard Brand Mark are registered trademarks of Mastercard International Incorporated. Pleo Financial Services A/S is a regulated Electronic Money Institution, authorised by the Financial Supervisory Authority, Denmark. Registered Office of Pleo Financial Services A/S: Ravnsborg Tværgade 5 C, 4. Copenhagen N, 2200, Denmark. CVR Number: 39155435. All communications should be sent to Pleo Technologies A/S, Ravnsborg Tværgade 5C, 2200 Copenhagen N, Denmark",
		copyright_text: "All rights reserved",
		financial_partner_terms_text: "",
		financial_partner_copyright_text: "",
		contact_us: "Chat with us",
		sales_email: null,
		info_email: null,
		support_email: null,
		product_heading: "Product",
		resources_heading: "Resources",
		company_heading: "Company",
		legal_heading: "Legal",
		solutions_heading: "Solutions",
		partnerships_heading: "",
		product_links: [{
			text: "Status",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://status.pleo.io/"
			}
		}],
		resources_links: [{
			text: "Help Centre",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://help.pleo.io/en/"
			}
		}, {
			text: "Developers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://developers.pleo.io/reference/introduction"
			}
		}],
		company_links: [{
			text: "Careers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://www.pleo.io/en/careers"
			}
		}, {
			text: "Legal",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "/fr-be/legal"
			}
		}],
		legal_links: [
			{
				text: "Master Service Agreement",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-master-service-agreement-eea-eu.pdf"
				}
			},
			{
				text: "Privacy Policy",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-privacy-policy-en.pdf"
				}
			},
			{
				text: "Fraud awareness",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-fraud-awereness-en.pdf"
				}
			},
			{
				text: "Complaints process",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-complaint-process-en.pdf"
				}
			},
			{
				text: "Code of Conduct",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/en/code-of-conduct"
				}
			}
		],
		solutions_links: [],
		partnerships_links: []
	},
	"it-it": {
		entity: "Pleo Technologies A/S (36538686) and Pleo Financial Services A/S (39155435)",
		address: [{
			type: "paragraph",
			text: "Ravnsborg Tværgade 5C 2200 Copenhagen N Denmark",
			spans: []
		}],
		terms_body: "The Pleo Card is issued by Pleo Financial Services A/S pursuant to a license from Mastercard International Incorporated. Mastercard and the Mastercard Brand Mark are registered trademarks of Mastercard International Incorporated. Pleo Financial Services A/S is a regulated Electronic Money Institution, authorised by the Financial Supervisory Authority, Denmark. Registered Office of Pleo Financial Services A/S: Ravnsborg Tværgade 5 C, 4. Copenhagen N, 2200, Denmark. CVR Number: 39155435. All communications should be sent to Pleo Technologies A/S, Ravnsborg Tværgade 5C, 2200 Copenhagen N, Denmark",
		copyright_text: "All rights reserved",
		financial_partner_terms_text: "",
		financial_partner_copyright_text: "",
		contact_us: "Chat with us",
		sales_email: null,
		info_email: null,
		support_email: null,
		product_heading: "Product",
		resources_heading: "Resources",
		company_heading: "Company",
		legal_heading: "Legal",
		solutions_heading: "Solutions",
		partnerships_heading: "",
		product_links: [{
			text: "Status",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://status.pleo.io/"
			}
		}],
		resources_links: [{
			text: "Help Centre",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://help.pleo.io/en/"
			}
		}, {
			text: "Developers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://developers.pleo.io/reference/introduction"
			}
		}],
		company_links: [{
			text: "Careers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://www.pleo.io/en/careers"
			}
		}, {
			text: "Legal",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "/it/legal"
			}
		}],
		legal_links: [
			{
				text: "Master Service Agreement",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-master-service-agreement-eea-eu.pdf"
				}
			},
			{
				text: "Privacy Policy",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-privacy-policy-en.pdf"
				}
			},
			{
				text: "Fraud awareness",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-fraud-awereness-en.pdf"
				}
			},
			{
				text: "Complaints process",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-complaint-process-en.pdf"
				}
			},
			{
				text: "Code of Conduct",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/en/code-of-conduct"
				}
			}
		],
		solutions_links: [],
		partnerships_links: []
	},
	"no-no": {
		entity: "Pleo Technologies A/S (36538686) and Pleo Financial Services A/S (39155435)",
		address: [{
			type: "paragraph",
			text: "Ravnsborg Tværgade 5C 2200 Copenhagen N Denmark",
			spans: []
		}],
		terms_body: "The Pleo Card is issued by Pleo Financial Services A/S pursuant to a license from Mastercard International Incorporated. Mastercard and the Mastercard Brand Mark are registered trademarks of Mastercard International Incorporated. Pleo Financial Services A/S is a regulated Electronic Money Institution, authorised by the Financial Supervisory Authority, Denmark. Registered Office of Pleo Financial Services A/S: Ravnsborg Tværgade 5 C, 4. Copenhagen N, 2200, Denmark. CVR Number: 39155435. All communications should be sent to Pleo Technologies A/S, Ravnsborg Tværgade 5C, 2200 Copenhagen N, Denmark",
		copyright_text: "All rights reserved",
		financial_partner_terms_text: "",
		financial_partner_copyright_text: "",
		contact_us: "Chat with us",
		sales_email: null,
		info_email: null,
		support_email: null,
		product_heading: "Product",
		resources_heading: "Resources",
		company_heading: "Company",
		legal_heading: "Legal",
		solutions_heading: "Solutions",
		partnerships_heading: "",
		product_links: [{
			text: "Status",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://status.pleo.io/"
			}
		}],
		resources_links: [{
			text: "Help Centre",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://help.pleo.io/en/"
			}
		}, {
			text: "Developers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://developers.pleo.io/reference/introduction"
			}
		}],
		company_links: [{
			text: "Careers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://www.pleo.io/en/careers"
			}
		}, {
			text: "Legal",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "/no/legal"
			}
		}],
		legal_links: [
			{
				text: "Master Service Agreement",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-master-service-agreement-eea-eu.pdf"
				}
			},
			{
				text: "Privacy Policy",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-privacy-policy-en.pdf"
				}
			},
			{
				text: "Fraud awareness",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-fraud-awereness-en.pdf"
				}
			},
			{
				text: "Complaints process",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-complaint-process-en.pdf"
				}
			},
			{
				text: "Code of Conduct",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/en/code-of-conduct"
				}
			}
		],
		solutions_links: [],
		partnerships_links: []
	},
	"en-lu": {
		entity: "Pleo Technologies A/S (36538686) and Pleo Financial Services A/S (39155435)",
		address: [{
			type: "paragraph",
			text: "Ravnsborg Tværgade 5C 2200 Copenhagen N Denmark",
			spans: []
		}],
		terms_body: "The Pleo Card is issued by Pleo Financial Services A/S pursuant to a license from Mastercard International Incorporated. Mastercard and the Mastercard Brand Mark are registered trademarks of Mastercard International Incorporated. Pleo Financial Services A/S is a regulated Electronic Money Institution, authorised by the Financial Supervisory Authority, Denmark. Registered Office of Pleo Financial Services A/S: Ravnsborg Tværgade 5 C, 4. Copenhagen N, 2200, Denmark. CVR Number: 39155435. All communications should be sent to Pleo Technologies A/S, Ravnsborg Tværgade 5C, 2200 Copenhagen N, Denmark",
		copyright_text: "All rights reserved",
		financial_partner_terms_text: "",
		financial_partner_copyright_text: "",
		contact_us: "Chat with us",
		sales_email: null,
		info_email: null,
		support_email: null,
		product_heading: "Product",
		resources_heading: "Resources",
		company_heading: "Company",
		legal_heading: "Legal",
		solutions_heading: "Solutions",
		partnerships_heading: "",
		product_links: [{
			text: "Status",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://status.pleo.io/"
			}
		}],
		resources_links: [{
			text: "Help Centre",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://help.pleo.io/en/"
			}
		}, {
			text: "Developers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://developers.pleo.io/reference/introduction"
			}
		}],
		company_links: [{
			text: "Careers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://www.pleo.io/en/careers"
			}
		}, {
			text: "Legal",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "/lu/legal"
			}
		}],
		legal_links: [
			{
				text: "Master Service Agreement",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-master-service-agreement-eea-eu.pdf"
				}
			},
			{
				text: "Privacy Policy",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-privacy-policy-en.pdf"
				}
			},
			{
				text: "Fraud awareness",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-fraud-awereness-en.pdf"
				}
			},
			{
				text: "Complaints process",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-complaint-process-en.pdf"
				}
			},
			{
				text: "Code of Conduct",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/en/code-of-conduct"
				}
			}
		],
		solutions_links: [],
		partnerships_links: []
	},
	"et-ee": {
		entity: "Pleo Technologies A/S (36538686) and Pleo Financial Services A/S (39155435)",
		address: [{
			type: "paragraph",
			text: "Ravnsborg Tværgade 5C 2200 Copenhagen N Denmark",
			spans: []
		}],
		terms_body: "The Pleo Card is issued by Pleo Financial Services A/S pursuant to a license from Mastercard International Incorporated. Mastercard and the Mastercard Brand Mark are registered trademarks of Mastercard International Incorporated. Pleo Financial Services A/S is a regulated Electronic Money Institution, authorised by the Financial Supervisory Authority, Denmark. Registered Office of Pleo Financial Services A/S: Ravnsborg Tværgade 5 C, 4. Copenhagen N, 2200, Denmark. CVR Number: 39155435. All communications should be sent to Pleo Technologies A/S, Ravnsborg Tværgade 5C, 2200 Copenhagen N, Denmark",
		copyright_text: "All rights reserved",
		financial_partner_terms_text: "",
		financial_partner_copyright_text: "",
		contact_us: "Chat with us",
		sales_email: null,
		info_email: null,
		support_email: null,
		product_heading: "Product",
		resources_heading: "Resources",
		company_heading: "Company",
		legal_heading: "Legal",
		solutions_heading: "Solutions",
		partnerships_heading: "",
		product_links: [{
			text: "Status",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://status.pleo.io/"
			}
		}],
		resources_links: [{
			text: "Help Centre",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://help.pleo.io/en/"
			}
		}, {
			text: "Developers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://developers.pleo.io/reference/introduction"
			}
		}],
		company_links: [{
			text: "Careers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://www.pleo.io/en/careers"
			}
		}, {
			text: "Legal",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "/ee/legal"
			}
		}],
		legal_links: [
			{
				text: "Master Service Agreement",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-master-service-agreement-eea-eu.pdf"
				}
			},
			{
				text: "Privacy Policy",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-privacy-policy-en.pdf"
				}
			},
			{
				text: "Fraud awareness",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-fraud-awereness-en.pdf"
				}
			},
			{
				text: "Complaints process",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-complaint-process-en.pdf"
				}
			},
			{
				text: "Code of Conduct",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/en/code-of-conduct"
				}
			}
		],
		solutions_links: [],
		partnerships_links: []
	},
	"fi-fi": {
		entity: "Pleo Technologies A/S (36538686) and Pleo Financial Services A/S (39155435)",
		address: [{
			type: "paragraph",
			text: "Ravnsborg Tværgade 5C 2200 Copenhagen N Denmark",
			spans: []
		}],
		terms_body: "The Pleo Card is issued by Pleo Financial Services A/S pursuant to a license from Mastercard International Incorporated. Mastercard and the Mastercard Brand Mark are registered trademarks of Mastercard International Incorporated. Pleo Financial Services A/S is a regulated Electronic Money Institution, authorised by the Financial Supervisory Authority, Denmark. Registered Office of Pleo Financial Services A/S: Ravnsborg Tværgade 5 C, 4. Copenhagen N, 2200, Denmark. CVR Number: 39155435. All communications should be sent to Pleo Technologies A/S, Ravnsborg Tværgade 5C, 2200 Copenhagen N, Denmark",
		copyright_text: "All rights reserved",
		financial_partner_terms_text: "",
		financial_partner_copyright_text: "",
		contact_us: "Chat with us",
		sales_email: null,
		info_email: null,
		support_email: null,
		product_heading: "Product",
		resources_heading: "Resources",
		company_heading: "Company",
		legal_heading: "Legal",
		solutions_heading: "Solutions",
		partnerships_heading: "",
		product_links: [{
			text: "Status",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://status.pleo.io/"
			}
		}],
		resources_links: [{
			text: "Help Centre",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://help.pleo.io/en/"
			}
		}, {
			text: "Developers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://developers.pleo.io/reference/introduction"
			}
		}],
		company_links: [{
			text: "Careers",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "https://www.pleo.io/en/careers"
			}
		}, {
			text: "Legal",
			link: {
				link_type: "Web",
				uid: "",
				type: "",
				lang: void 0,
				target: "",
				url: "/fi/legal"
			}
		}],
		legal_links: [
			{
				text: "Master Service Agreement",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-master-service-agreement-eea-eu.pdf"
				}
			},
			{
				text: "Privacy Policy",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-privacy-policy-en.pdf"
				}
			},
			{
				text: "Fraud awareness",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-fraud-awereness-en.pdf"
				}
			},
			{
				text: "Complaints process",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/legal-documents/pleo-complaint-process-en.pdf"
				}
			},
			{
				text: "Code of Conduct",
				link: {
					link_type: "Web",
					uid: "",
					type: "",
					lang: void 0,
					target: "",
					url: "https://www.pleo.io/en/code-of-conduct"
				}
			}
		],
		solutions_links: [],
		partnerships_links: []
	}
};
const getStaticFooter = (locale) => ({
	...lookupStatic(staticFooters, locale, "footer"),
	social_links: socialLinks
});
//#endregion
//#region src/adapters/static/header/index.ts
const staticHeaders = {
	"en-us": {
		logInText: "Log in",
		ctaButtonText: "Get started",
		noResultsText: "No results found",
		items: [
			{
				label: "Product",
				hideOn: "tablet",
				groups: [{
					label: "Features",
					links: [{
						text: "Business expense cards",
						href: "/us/business-expense-cards"
					}, {
						text: "Expense management",
						href: "/us/howitworks"
					}]
				}, {
					label: "Why Pleo?",
					links: [{
						text: "Overview",
						href: "/us/features"
					}, {
						text: "Spend controls",
						href: "/us/spend-controls"
					}]
				}]
			},
			{
				label: "Pricing",
				href: "/us/pricing",
				hideOn: "tablet"
			},
			{
				label: "Pricing Plans",
				hideOn: "all",
				groups: [{
					label: "Pricing",
					links: [{
						text: "Pricing Plans",
						href: "/us/pricing"
					}]
				}]
			}
		]
	},
	"pt-pt": {
		ctaButtonText: "Get Started",
		logInText: "Log in",
		noResultsText: "No results found",
		secondaryCtaText: "Book a demo",
		secondaryCtaHref: "/ie/demo?country=pt",
		items: [{
			label: "Pricing",
			href: "/pt/pricing",
			hideOn: "tablet"
		}, {
			label: "Pricing Plans",
			hideOn: "all",
			groups: [{
				label: "Pricing",
				links: [{
					text: "Pricing Plans",
					href: "/pt/pricing"
				}]
			}]
		}]
	},
	"de-at": {
		ctaButtonText: "Get Started",
		logInText: "Log in",
		noResultsText: "No results found",
		secondaryCtaText: "Book a demo",
		secondaryCtaHref: "/ie/demo?country=at",
		items: [{
			label: "Pricing",
			href: "/at/pricing",
			hideOn: "tablet"
		}, {
			label: "Pricing Plans",
			hideOn: "all",
			groups: [{
				label: "Pricing",
				links: [{
					text: "Pricing Plans",
					href: "/at/pricing"
				}]
			}]
		}]
	},
	"nl-be": {
		ctaButtonText: "Get Started",
		logInText: "Log in",
		noResultsText: "No results found",
		secondaryCtaText: "Book a demo",
		secondaryCtaHref: "/ie/demo?country=be",
		items: [{
			label: "Pricing",
			href: "/nl-be/pricing",
			hideOn: "tablet"
		}, {
			label: "Pricing Plans",
			hideOn: "all",
			groups: [{
				label: "Pricing",
				links: [{
					text: "Pricing Plans",
					href: "/nl-be/pricing"
				}]
			}]
		}]
	},
	"fr-be": {
		ctaButtonText: "Get Started",
		logInText: "Log in",
		noResultsText: "No results found",
		secondaryCtaText: "Book a demo",
		secondaryCtaHref: "/ie/demo?country=be",
		items: [{
			label: "Pricing",
			href: "/fr-be/pricing",
			hideOn: "tablet"
		}, {
			label: "Pricing Plans",
			hideOn: "all",
			groups: [{
				label: "Pricing",
				links: [{
					text: "Pricing Plans",
					href: "/fr-be/pricing"
				}]
			}]
		}]
	},
	"it-it": {
		ctaButtonText: "Get Started",
		logInText: "Log in",
		noResultsText: "No results found",
		secondaryCtaText: "Book a demo",
		secondaryCtaHref: "/ie/demo?country=it",
		items: [{
			label: "Pricing",
			href: "/it/pricing",
			hideOn: "tablet"
		}, {
			label: "Pricing Plans",
			hideOn: "all",
			groups: [{
				label: "Pricing",
				links: [{
					text: "Pricing Plans",
					href: "/it/pricing"
				}]
			}]
		}]
	},
	"no-no": {
		ctaButtonText: "Get Started",
		logInText: "Log in",
		noResultsText: "No results found",
		secondaryCtaText: "Book a demo",
		secondaryCtaHref: "/ie/demo?country=no",
		items: [{
			label: "Pricing",
			href: "/no/pricing",
			hideOn: "tablet"
		}, {
			label: "Pricing Plans",
			hideOn: "all",
			groups: [{
				label: "Pricing",
				links: [{
					text: "Pricing Plans",
					href: "/no/pricing"
				}]
			}]
		}]
	},
	"en-lu": {
		ctaButtonText: "Get Started",
		logInText: "Log in",
		noResultsText: "No results found",
		secondaryCtaText: "Book a demo",
		secondaryCtaHref: "/ie/demo?country=lu",
		items: [{
			label: "Pricing",
			href: "/lu/pricing",
			hideOn: "tablet"
		}, {
			label: "Pricing Plans",
			hideOn: "all",
			groups: [{
				label: "Pricing",
				links: [{
					text: "Pricing Plans",
					href: "/lu/pricing"
				}]
			}]
		}]
	},
	"et-ee": {
		ctaButtonText: "Get Started",
		logInText: "Log in",
		noResultsText: "No results found",
		secondaryCtaText: "Book a demo",
		secondaryCtaHref: "/ie/demo?country=ee",
		items: [{
			label: "Pricing",
			href: "/ee/pricing",
			hideOn: "tablet"
		}, {
			label: "Pricing Plans",
			hideOn: "all",
			groups: [{
				label: "Pricing",
				links: [{
					text: "Pricing Plans",
					href: "/ee/pricing"
				}]
			}]
		}]
	},
	"fi-fi": {
		ctaButtonText: "Get Started",
		logInText: "Log in",
		noResultsText: "No results found",
		secondaryCtaText: "Book a demo",
		secondaryCtaHref: "/ie/demo?country=fi",
		items: [{
			label: "Pricing",
			href: "/fi/pricing",
			hideOn: "tablet"
		}, {
			label: "Pricing Plans",
			hideOn: "all",
			groups: [{
				label: "Pricing",
				links: [{
					text: "Pricing Plans",
					href: "/fi/pricing"
				}]
			}]
		}]
	}
};
const getStaticHeader = (locale) => lookupStatic(staticHeaders, locale, "header");
//#endregion
export { socialLinks as a, staticFooters as i, staticHeaders as n, PrismicLinkTypeEnum as o, getStaticFooter as r, getStaticHeader as t };
